(function(){
const init=()=>document.querySelectorAll('[data-pm-builder-weather]').forEach(root=>{
if(root.dataset.ready==='true')return;
root.dataset.ready='true';
    const locale = root.dataset.locale || document.documentElement.lang;
    const copy = JSON.parse(root.querySelector('[data-pm-weather-copy]').textContent);
    const place = root.dataset.place;
    const setValue = (key, value) => {
      root.querySelectorAll(`[data-weather="${key}"]`).forEach(node=>{node.textContent=value;});
    };

    const showUnavailable = (regional = false) => {
      root.classList.add('pm-weather-unavailable');
      setValue('condition', regional ? copy.text_1 : copy.text_2);
      setValue('summary', regional ? copy.text_3 : copy.text_4);
      setValue('status', '');
    };

    const weatherText = {
      0: [copy.text_5, '☀'],
      1: [copy.text_6, '🌤'],
      2: [copy.text_7, '⛅'],
      3: [copy.text_8, '☁'],
      45: [copy.text_9, '🌫'],
      48: [copy.text_10, '🌫'],
      51: [copy.text_11, '🌦'],
      53: [copy.text_12, '🌦'],
      55: [copy.text_13, '🌧'],
      61: [copy.text_14, '🌦'],
      63: [copy.text_15, '🌧'],
      65: [copy.text_16, '🌧'],
      80: [copy.text_17, '🌦'],
      81: [copy.text_18, '🌧'],
      82: [copy.text_19, '🌧'],
      95: [copy.text_20, '⛈'],
      96: [copy.text_21, '⛈'],
      99: [copy.text_22, '⛈']
    };
    const showWeather = (latitude, longitude, elevation) => {
      const forecastUrl = 'https://api.open-meteo.com/v1/forecast?latitude='
        + encodeURIComponent(latitude) + '&longitude=' + encodeURIComponent(longitude)
        + '&current=temperature_2m,relative_humidity_2m,apparent_temperature,weather_code,wind_speed_10m'
        + '&daily=precipitation_probability_max,uv_index_max,sunset&timezone=America%2FLima&forecast_days=1';
      return fetch(forecastUrl, { signal: AbortSignal.timeout(10000) })
        .then((response) => {
          if (!response.ok) throw new Error('weather');
          return response.json();
        })
        .then((data) => {
          const current = data.current || {};
          const daily = data.daily || {};
          const code = Number(current.weather_code || 0);
          const description = weatherText[code] || [copy.text_23, '☁'];
          const temperature = Math.round(Number(current.temperature_2m || 0));
          const feels = Math.round(Number(current.apparent_temperature || temperature));
          const humidity = Math.round(Number(current.relative_humidity_2m || 0));
          const wind = Math.round(Number(current.wind_speed_10m || 0));
          const rain = Math.round(Number((daily.precipitation_probability_max || [0])[0] || 0));
          const uv = Number((daily.uv_index_max || [0])[0] || 0);
          const sunset = String((daily.sunset || [''])[0]).split('T')[1]?.slice(0, 5);
          setValue('temperature', temperature + ' °C');
          setValue('symbol', description[1]);
          setValue('condition', description[0]);
          setValue('summary', copy.summary.replace('__temperature__',feels).replace('__place__',place));
          setValue('status', copy.updated.replace('__date__',new Date().toLocaleDateString(locale,{timeZone:'America/Lima'})));
          setValue('uv', uv < 3 ? copy.text_27 : uv < 6 ? copy.text_28 : uv < 8 ? copy.text_29 : uv < 11 ? copy.text_30 : copy.text_31);
          setValue('wind', wind + ' km/h');
          setValue('rain', rain + ' %');
          setValue('humidity', humidity + ' %');
          setValue('sunset', sunset ? copy.sunset.replace('__time__',sunset) : '–');
          setValue('elevation', Math.round(Number(elevation || 0)) + ' m');
          if (rain >= 45) {
            setValue('tip-title', copy.text_33);
            setValue('tip', copy.text_34);
          } else if (uv >= 8) {
            setValue('tip-title', copy.text_35);
            setValue('tip', copy.text_36);
          } else if (temperature >= 29) {
            setValue('tip-title', copy.text_37);
            setValue('tip', copy.text_38);
          }
        });
    };
    const geocodeUrl = 'https://geocoding-api.open-meteo.com/v1/search?name='
      + encodeURIComponent(place) + '&count=1&language=de&countryCode=PE&format=json';
    fetch(geocodeUrl, { signal: AbortSignal.timeout(10000) })
      .then((response) => {
        if (!response.ok) throw new Error('place');
        return response.json();
      })
      .then((data) => {
        const result = data.results?.[0];
        if (!result) throw new Error('place');
        return showWeather(result.latitude, result.longitude, result.elevation);
      })
      .catch(() => showUnavailable());

});
init();document.addEventListener('shopify:section:load',init);
})();
